import { Controller } from '@hotwired/stimulus'

// Shows and hides a filter panel that is collapsed at narrow widths.
//
// The panel keeps `lg:block` so it is always open once there is room beside the
// list, and the button keeps `lg:hidden` so it disappears at the same width —
// toggling `hidden` only decides the narrow case.
//
// Choosing a filter reloads the page, which would otherwise hand back the
// server's collapsed default after every click, so the panel remembers whether
// it was open. sessionStorage rather than localStorage: staying open belongs to
// the run of clicks someone is making now, while a fresh visit is better off
// with the list in view.
//
//   <div data-controller="filter-panel">
//     <button data-action="click->filter-panel#toggle"
//             data-filter-panel-target="button"
//             aria-controls="panel_id" aria-expanded="false">
//     <div id="panel_id" class="hidden lg:block" data-filter-panel-target="panel">
export default class extends Controller {
  static targets = ['button', 'panel']

  connect () {
    if (window.sessionStorage.getItem(this.#storageKey) === 'open') this.#apply(true)
  }

  toggle () {
    this.#apply(this.panelTarget.classList.contains('hidden'))
  }

  #apply (expanded) {
    this.panelTarget.classList.toggle('hidden', !expanded)

    if (this.hasButtonTarget) this.buttonTarget.setAttribute('aria-expanded', String(expanded))

    window.sessionStorage.setItem(this.#storageKey, expanded ? 'open' : 'closed')
  }

  // Keyed by the panel, so two collapsible panels on a page don't share a state.
  get #storageKey () {
    return `filter-panel:${this.panelTarget.id}`
  }
}
